// Auto-generated normalizer for table: Cuestionario
export function cuestionarioNormalize(row) {
  return {
    idCuestionario: row.idCuestionario ?? row.IdCuestionario ?? row['IdCuestionario'] ?? 0,
    idCurso: row.idCurso ?? row.IdCurso ?? row['IdCurso'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    preguntasAleatorias: row.preguntasAleatorias ?? row.PreguntasAleatorias ?? row['PreguntasAleatorias'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
